import React, { useContext, useState } from "react";
import {
    Input, Form, DatePicker, InputNumber, Select
} from "antd";
import { PaymentContext } from "../../../common/PaymentContext";
const CardBankForm = () => {
    const { cardBankNumber, setCardBankNumber } = useContext(PaymentContext);
    const { expirationDate, setExpirationDate } = useContext(PaymentContext);
    const { cvv, setCvv } = useContext(PaymentContext)

    const handleChange = (value) => {
        console.log(value);
    }


    return (
        <div>
            <Form
                /*  labelCol={{ span: 4 }}
                 wrapperCol={{ span: 14 }} */
                layout="vertical"
                style={{
                    display: 'flex',
                    flexDirection: 'column', // Alignement vertical
                    alignItems: 'center', // Centre horizontalement
                    justifyContent: 'center',
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}>
                    <Select
                        defaultValue="lucy"
                        style={{ width: 120 }}
                        onChange={handleChange}
                        options={[
                            { value: 'jack', label: 'Visa' },
                            { value: 'lucy', label: 'Mastercard' },
                        ]}
                    />
                    <Form.Item style={{ width: '70%' }}>
                        <Input placeholder="Entrer votre numéro de carte" onChange={(e) => setCardBankNumber(e.target.value)} />
                    </Form.Item>
                </div>

                <div style={{ display: 'flex', justifyContent: 'center', width: '70%' }}>
                    <Form.Item style={{width: '70%'}}>
                        <DatePicker placeholder="Date d'expiration" format="DD/MM/YYYY" // Le format de la date en français
                            onChange={(date, dateString) => setExpirationDate(dateString)} />
                    </Form.Item>
                    <Form.Item style={{width: '70%'}}>
                        <InputNumber placeholder="CVV" onChange={(e) => setCvv(e.target.value)} />
                    </Form.Item>
                </div>

            </Form>

        </div >
    )
}

export default CardBankForm;